import React from 'react';
import { weddingVideos } from '../../data/weddingVideos';
export function WeddingVideos() {
  return <section className="border-t border-ink/10 px-6 py-16" aria-labelledby="videos-heading" data-id="element-91" data-mp="2tvqpw3z0aa54">
      <div className="mx-auto max-w-4xl" data-id="element-92" data-mp="2ovw1c72pdwn8">
        <h2 id="videos-heading" className="text-center font-display text-3xl text-ink" data-id="element-93" data-mp="2oz08ndbgt8i4">
          Successful <em className="text-gold" data-id="element-94" data-mp="2kxoj17slcn9x">Weddings</em>
        </h2>
        <p className="mt-2 text-center font-body text-sm text-ink/60" data-id="element-95" data-mp="2fx0uqtvqykje">
          Real celebrations at Twenty Mile House, just as they happened.
        </p>
        <ul className="mt-10 grid grid-cols-1 gap-x-5 gap-y-8 sm:grid-cols-2 md:grid-cols-3" data-id="element-96" data-mp="266foqldqudqg">
          {weddingVideos.map(video => <li key={video.id} data-id="element-97" data-mp="218e784vyumh3">
              <div className="aspect-video w-full overflow-hidden bg-ink/5" data-id="element-98" data-mp="2159sweoseacp">
                <iframe className="h-full w-full" src={`https://www.youtube-nocookie.com/embed/${video.id}`} title={`${video.couple} wedding film`} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-99" data-mp="1x581cycrmxb5" />
              </div>
              <p className="mt-2.5 text-center font-body text-sm text-ink/70" data-id="element-100" data-mp="28rutuorjult8">{video.couple}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}